/**
 * adSlotShared.js — shared helpers for the Ad Slot block (public + editor).
 */
import { buildEmbedTag } from '@/websites/cms/blocks/shared/blockUtils.js';

export var SIZE_LABELS = {
	leaderboard: '728 × 90',
	rectangle: '300 × 250',
	halfPage: '300 × 600',
	mobile: '320 × 50',
	auto: 'Auto size'
};

/** `mos-creative` attributes as a plain object (tolerates a JSON string from older content). */
export function normalizeAdAttrs(value) {
	if (typeof value === 'string' && value.trim()) {
		try { value = JSON.parse(value); } catch (e) { return {}; }
	}
	return (value && typeof value === 'object' && !Array.isArray(value)) ? value : {};
}

/** True when the MediaOS source is configured enough to serve (a product is chosen). */
export function hasMediaosUnit(adAttrs) {
	var a = normalizeAdAttrs(adAttrs);
	return !!a['product-id'];
}

/** The public markup for the slot, or '' when there is nothing to render. */
export function buildAdSlotMarkup(provider, adAttrs, embedCode) {
	if ((provider || 'mediaos') === 'external') {
		return (embedCode && embedCode.trim()) ? embedCode : '';
	}
	return hasMediaosUnit(adAttrs) ? buildEmbedTag('mos-creative', normalizeAdAttrs(adAttrs)) : '';
}
